import { render, staticRenderFns } from "./Question_simple.vue?vue&type=template&id=3d9774cc&"
import script from "./Question_simple.vue?vue&type=script&lang=js&"
export * from "./Question_simple.vue?vue&type=script&lang=js&"
import style0 from "./Question_simple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports